import {AlertIcon} from '@primer/octicons-react'
import {SkeletonBox, SkeletonText} from '@primer/react/experimental'
import {clsx} from 'clsx'
import styles from './ForYouItem.module.css'
import {useRegisterAsVisible} from './ForYouSubSection'

/**
 * Skeleton placeholder rendered while a ForYouItem's async content loads.
 * Mirrors the collapsed-header shape of ForYouItem so the layout is stable.
 */
export function ForYouItemSkeleton() {
  useRegisterAsVisible()

  return (
    <li className={styles.container} aria-busy="true">
      <div className={clsx(styles.headerRow, styles.nonInteractive)}>
        <SkeletonBox height="28px" width="28px" />
        <SkeletonBox height="16px" width="16px" />
        <span className={styles.headerText}>
          <SkeletonText size="bodyMedium" />
        </span>
      </div>
    </li>
  )
}

/**
 * Error state rendered when a ForYouItem's content throws.
 * Matches the collapsed-header shape so the list layout is preserved.
 */
export function ForYouItemError() {
  useRegisterAsVisible()

  return (
    <li className={styles.container}>
      <div className={clsx(styles.headerRow, styles.nonInteractive)}>
        <span className={clsx(styles.leadingIcon, styles.danger)}>
          <AlertIcon size={16} />
        </span>
        <span className={styles.headerText}>
          <span className={styles.titleRow}>
            <span className={styles.title}>Unable to load this item</span>
          </span>
          <span className={styles.descriptionRow}>
            <span className={styles.description}>Try reloading the page.</span>
          </span>
        </span>
      </div>
    </li>
  )
}
